import { useFavorites, IconButton } from '@tunasong/ui-lib'
import { Header } from '../header.js'
import { Link as RouterLink } from 'react-router'
import { Favorite, FavoriteBorder, Home, type IconName } from '@tunasong/icons'
import cn from 'classnames'
import type { HTMLAttributes } from 'react'
import styles from './page-header.module.css'

export interface PageHeaderProps extends HTMLAttributes<HTMLDivElement> {
  name?: string
  pageIconName?: IconName
  ref?: React.Ref<HTMLDivElement>
  showBackButton?: boolean
}

export const PageHeader = (props: PageHeaderProps) => {
  const { name, ref, showBackButton = true, pageIconName, ...restProps } = props
  const { currentFavorite, addFavorite, removeFavorite } = useFavorites()

  return (
    <Header
      ref={ref}
      position="absolute"
      elevation={0}
      controls={[
        name ? (
          <IconButton
            key={0}
            color={currentFavorite ? 'error' : 'inherit'}
            onClick={ev => {
              ev.preventDefault()
              ev.stopPropagation()
              if (currentFavorite) {
                removeFavorite(currentFavorite)
              } else {
                addFavorite({ name, iconName: pageIconName })
              }
            }}
            aria-label={currentFavorite ? 'Remove from favorites' : 'Add to favorites'}
          >
            {currentFavorite ? <Favorite /> : <FavoriteBorder />}
          </IconButton>
        ) : null,
      ].filter(Boolean)}
      showBackButton={showBackButton}
      breadcrumbs={
        <nav aria-label="breadcrumb" className={styles.breadcrumb}>
          <RouterLink className={cn(styles.link, styles.homeLink)} to="/app" title="Home link" aria-label="Home link">
            <Home size={24} />
          </RouterLink>
          {name ? <span className={styles.separator}>/</span> : null}
          {name ? (
            <RouterLink className={cn(styles.link, styles.nameLink)} to={`.`} title={name}>
              {name}
            </RouterLink>
          ) : null}
        </nav>
      }
      {...restProps}
    />
  )
}
